import React, {Fragment} from "react";
import {useLocation} from "react-router-dom";
import {Button} from "reactstrap";
import ZeusButton from "../../../components/Button";

const SensorConfigButtons = (props) => {
  const {pageSections = [], metadataIndex, handleNavClick, handleSubmit} = props;
  const activePageSectionIndex = pageSections.findIndex((section = {}) => section.active);
  const onLastPage = activePageSectionIndex === pageSections.length - 1;

  const location = useLocation();
  const routeAction = location?.state?.action;

  const handleButtonClick = (action) => {
    switch (action) {
      case "previous":
        handleNavClick(metadataIndex, pageSections[activePageSectionIndex - 1]?.slug);
        break;
      case "next":
        handleNavClick(metadataIndex, pageSections[activePageSectionIndex + 1]?.slug);
        break;
      case "first":
        handleNavClick(metadataIndex, pageSections[0]?.slug);
        break;
      case "last":
        handleNavClick(metadataIndex, pageSections[pageSections?.length - 1]?.slug);
        break;
    }
  };

  return (
    <Fragment>
      {activePageSectionIndex > 0 && (
        <div className="sensor--edit--button">
          <Button
            className="sensor--edit--button--inner"
            data-cy={"previous_button"}
            onClick={() => handleButtonClick("previous")}
          >
            Previous
          </Button>
        </div>
      )}
      {onLastPage && (
        <div className="sensor--edit--button">
          <Button
            className="sensor--edit--button--inner"
            onClick={() => handleButtonClick("first")}
          >
            Back to First
          </Button>
        </div>
      )}
      {!onLastPage && (
        <div className="sensor--edit--button">
          <Button
            className="sensor--edit--button--inner"
            data-cy={"skip_to_last_button"}
            onClick={() => handleButtonClick("last")}
          >
            Skip to last
          </Button>
        </div>
      )}
      {!onLastPage && (
        <div className="sensor--edit--button">
          <Button
            className="sensor--edit--button--inner"
            data-cy={"next_button"}
            onClick={() => handleButtonClick("next")}
          >
            Next
          </Button>
        </div>
      )}
      {onLastPage && routeAction === "Edit" && (
        <div className="sensor--edit--button">
          <ZeusButton onClick={handleSubmit} data-cy="submit-btn">
            Submit config
          </ZeusButton>
        </div>
      )}
    </Fragment>
  );
};

export default SensorConfigButtons;
